<template>
	<PageTitle>Конструктивы</PageTitle>
	<CustomTable :rowsData="this.rowsData" :columns="constructivesTableColumns" :stickyHeader="true" :loading="isFetching"
		:custom-body="true" :small="true" :height="300">
		<template #customBody="props" v-if="!isFetching">
			<q-tr>
				<custom-table-cell align="left" vertical-align="center">
					{{ props.row.work_set_name }}
				</custom-table-cell>

				<custom-table-cell align="center" vertical-align="center" style="width: 250px;">
					<div v-if="props.row.check_lists && props.row.check_lists.length > 0" class="check-lists-cell">
						<Clickable @click="openCheckListsPopup(props.row.check_lists)">
							Посмотреть чек-листы ({{ props.row.check_lists.length }})
						</Clickable>
						<q-popup-proxy v-if="checkListsPopupOpen">
							<q-card style="max-width: 500px; max-height: 400px; overflow-y: auto;" bordered>
								<q-card-section class="check-lists-popup-header">
									<div class="text-h6">Чек-листы ({{ props.row.check_lists.length }})</div>
								</q-card-section>
								<q-separator />
								<q-card-section class="check-lists-popup-content">
									<div v-for="(checkList, index) in props.row.check_lists" :key="checkList.check_list_id"
										class="check-list-popup-item">
										<div class="check-list-popup-name">
											<span class="check-list-number">{{ index + 1 }}.</span>
											{{ checkList.check_name }}
											<div v-if="checkList.norm" class="check-list-popup-norm">
												<q-chip dense size="sm" outline color="grey-7">
													Норма: {{ checkList.norm }}
												</q-chip>
											</div>
											<div v-if="checkList.is_required" class="check-list-popup-required">
												<q-badge color="warning" label="Обязательный" />
											</div>
										</div>
									</div>
								</q-card-section>
							</q-card>
						</q-popup-proxy>
					</div>
					<span v-else class="text-grey-6">—</span>
				</custom-table-cell>

				<custom-table-cell align="center" vertical-align="center" style="width: 150px;">
					{{ props.row.is_active === 1 ? 'Да' : 'Нет' }}
				</custom-table-cell>

				<custom-table-cell align="center" vertical-align="center">
					{{ props.row.formula }}
				</custom-table-cell>

				<custom-table-cell align="center" vertical-align="center" style="width: 150px;">
					<CustomDropdown @click="(action) => handleAction(action, props.row)" :options="this.getActionsDropdown()"
						title="Действие" />
				</custom-table-cell>
			</q-tr>
		</template>
	</CustomTable>
	<div class="bind-check-lists-drawer">
		<q-drawer v-model="bindCheckListsDrawerOpen" side="right" overlay :width="800" bordered>
			<BindCheckListsDrawer v-if="bindCheckListsDrawerOpen && activeWorkSet" :work-set="activeWorkSet"
				@close="bindCheckListsDrawerOpen = false" @success="getData" />
		</q-drawer>
	</div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import {
	constructivesTableColumns,
	getWorkSetChecks
} from "@/views/Constructives/services";
import { getConstructiveList } from "@/views/PackageEntry/services";
import CustomDropdown from "@/components/common/CustomDropdown";
import BindCheckListsDrawer from "@/views/Constructives/BindCheckListsDrawer.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import Clickable from "@/components/common/Clickable";

export default {
	name: "Constructives",
	components: { CustomTableCell, CustomTable, CustomDropdown, BindCheckListsDrawer, PageTitle, Clickable },
	data() {
		return {
			constructivesTableColumns,
			rowsData: [],
			totalRecords: 0,
			isFetching: false,
			activeWorkSet: null,
			bindCheckListsDrawerOpen: false,
			checkListsPopupOpen: false,
		}
	},
	methods: {
		openCheckListsPopup(checkLists) {
			this.checkListsPopupOpen = true
			this.checkLists = checkLists
		},
		getActionsDropdown() {
			return [
				{ label: 'Привязать чек-листы', action: 'bindCheckLists' },
			]
		},
		handleAction(action, row) {
			if (action.action === 'bindCheckLists') {
				this.openBindCheckListsDrawer(row)
			}
		},
		openBindCheckListsDrawer(row) {
			this.activeWorkSet = row
			this.bindCheckListsDrawerOpen = true
		},
		async getData() {
			this.isFetching = true
			const res = await getWorkSetChecks()
			if (!res) return;
			this.isFetching = false
			this.rowsData = res || []
		},
		refetch() {
			this.getData();
		},
	},
	mounted() {
		this.getData()
	},
}
</script>

<style scoped lang="scss">
.sbsCompany {
	height: calc(100vh - 120px);
	display: flex;
	flex-direction: column;
}

.sbsCompany__filters {
	margin-bottom: 25px;
	display: flex;
	gap: 20px;
	align-items: flex-end;

	.sbsCompany__filter {
		width: 250px;
	}
}

.check-lists-cell {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;

	.check-lists-badge {
		font-size: 12px;
		font-weight: 600;
	}

	.check-lists-info-btn {
		padding: 4px;
		color: #666;

		&:hover {
			color: #1976d2;
		}
	}
}

.check-lists-popup-header {
	padding: 12px 16px;
	background: #fafafa;

	.text-h6 {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
	}
}

.check-lists-popup-content {
	padding: 12px 16px;

	.check-list-popup-item {
		padding: 12px 0;
		border-bottom: 1px solid #f0f0f0;

		&:last-child {
			border-bottom: none;
		}

		.check-list-popup-name {
			font-size: 14px;
			line-height: 1.5;
			color: #1a1a1a;
			margin-bottom: 6px;

			.check-list-number {
				font-weight: 600;
				color: #666;
				margin-right: 6px;
			}
		}

		.check-list-popup-norm {
			margin: 6px 0;
		}

		.check-list-popup-required {
			margin-top: 6px;
		}
	}
}
</style>